import { render, staticRenderFns } from "./AssistantServiceUpsertForm.vue?vue&type=template&id=a3d51dc4"
import script from "./AssistantServiceUpsertForm.vue?vue&type=script&lang=js"
export * from "./AssistantServiceUpsertForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports